export default function WidgetCard({ children, title }) {
  return (
    <div className="bg-white shadow-lg rounded-lg p-4 w-full">
      <div className="font-bold text-slate-500 text-center mb-4">{title}</div>
      {children}
    </div>
  );
}
